import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "22",
        cy: "22",
        r: "22",
        fill: "var(--status-svg-color)"
      }),
      _createElementVNode("g", {
        stroke: "#FFF",
        "stroke-width": "2"
      }, [
        _createElementVNode("path", { d: "M26 13h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M18 27l-5-5 5-5M14 22h12" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }